import { gql } from "@/__generated__/gql";

export const SOCIAL_MEDIA_PLATFORMS = gql(`
  query SocialMediaPlatforms {
    socialMediaPlatforms {
      nodes {
        id
        name
        baseUrl
        icon {
          url(size: 100)
        }
      }
    }
  }
`);
